module.exports = __webpack_public_path__ + "img/scene_deep_dive_big@2x.1b7db8bc.png";